import { render, staticRenderFns } from "./EditCorrectionView.vue?vue&type=template&id=8a80c60a&scoped=true&"
import script from "./EditCorrectionView.vue?vue&type=script&lang=js&"
export * from "./EditCorrectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a80c60a",
  null
  
)

export default component.exports